import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid } from '@mui/material';
import React, { useState } from 'react';
import { handleError, storeData } from "../Shared/Functions"
import { BillingAccountsVService } from '../../services/V3/gozer';

export function AccountsModal({ hide, show, accounts, setAccount, errorToast }) {
    const [loading, setLoading] = useState<boolean>(false);

    const changeAccount = (account) => {
        setLoading(true)
        BillingAccountsVService.billingAccountsVGetById(account.id)
            .then((fullAcct: any) => {
                setLoading(false)
                setAccount(fullAcct)
                storeData("billingAccount", fullAcct)
                hide(account.id)
            })
            .catch(err => errorToast(handleError(err)))
    }

    return (loading ? <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
        <Dialog onClose={() => hide()} open={show} fullWidth={true}>
            <DialogTitle>Select Account</DialogTitle>
            <DialogContent>
                {accounts.map(x => (
                    <>
                        <Grid container xs={12} className="account-select-modal"
                            onClick={() => changeAccount(x)}>
                                <Grid item className='account-select-modal-item'><b>Account Number</b></Grid>
                                <Grid item className='account-select-modal-item'>{x.accountNumber}</Grid>
                                <Grid item className='account-select-modal-item'><b>Name</b></Grid>
                                <Grid item className='account-select-modal-item'>{x.customer.fullName}</Grid>
                                <Grid item className='account-select-modal-item'><b>Address</b></Grid>
                                <Grid item className='account-select-modal-item'>
                                    {x?.services ? x?.services[0]?.serviceAddress?.street : "N/A"}
                                </Grid>
                        </Grid>
                        <Divider />
                    </>
                ))}
            </DialogContent>
            <DialogActions className='select-account-buttons-group'>
                <Button variant="outlined" onClick={() => hide()}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>)
}
